/** Textos institucionais e versões dos textos legais exibidos no chat. */

/** Aviso fixo no chat. */
export const DISCLAIMER = 'Assistente virtual com IA. O valor do sistema e a economia dependem da análise do seu consumo.';

/** Versões dos textos legais. Suba a versão sempre que o texto mudar: o consentimento grava a versão mostrada. */
export const LEGAL_VERSIONS = {
  consent: '1-2026-10-15',
} as const;

export const COMPANY = {
  name: 'Sun Coast Energia Solar',
  site: 'https://suncoastenergiasolar.com.br',
  privacy: 'https://suncoastenergiasolar.com.br/politica-de-privacidade/',
} as const;
